import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { escucharInstalacion } from "./pwa/instalar";
import { registrarServiceWorker } from "./pwa/registrar-sw";
import "./ui/tokens.css";
import "./ui/estilos.css";

// Antes de pintar: `beforeinstallprompt` llega una vez y puede llegar ya (OD-0065).
escucharInstalacion();

const raiz = document.getElementById("raiz");
if (raiz === null) throw new Error("Falta el elemento #raiz en index.html.");

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registrarServiceWorker();
